export default __webpack_public_path__ + "static/media/mobile_74.f2efee74.jpg";